module.exports = __webpack_public_path__ + "img/04_Boton_Conectividad.8a9e8eee.png";